import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import BackDrop from '../BackDrop';
import classes from './Drawer.module.scss';

const Drawer = ({
  isOpen,
  onClose,
  children,
  position = 'bottom',
  customClass,
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const { overflow } = document.body.style;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = overflow;
    };
  }, [isOpen]);

  const transition = { type: 'spring', stiffness: 320, damping: 32 };

  const isBottom = position === 'bottom';
  const initial = isBottom ? { y: '100%' } : { x: '100%' };
  const animate = isBottom ? { y: 0 } : { x: 0 };
  const exit = initial;

  const handleDragEnd = (_, info) => {
    if (info.offset.y > 120 || info.velocity.y > 500) {
      onClose();
    }
  };

  if (typeof document === 'undefined') return null;

  return ReactDOM.createPortal(
    <AnimatePresence>
      {isOpen && (
        <>
          <BackDrop onClick={onClose} />
          <motion.div
            className={
              classes.Drawer +
              ' ' +
              (isBottom ? classes.Bottom : classes.Right) +
              (customClass ? ' ' + customClass : '')
            }
            initial={initial}
            animate={animate}
            exit={exit}
            transition={transition}
            drag={isBottom ? 'y' : false}
            dragConstraints={isBottom ? { top: 0, bottom: 0 } : undefined}
            dragElastic={isBottom ? { top: 0, bottom: 0.5 } : undefined}
            onDragEnd={isBottom ? handleDragEnd : undefined}
          >
            {children}
          </motion.div>
        </>
      )}
    </AnimatePresence>,
    document.body
  );
};

export default Drawer;
